/**
 * A kiosk left mid-search by one visitor should not still be showing that
 * search — or someone else's exhibitor lookup — to the next person who
 * walks up. This resets the app to a blank "tap to find your way" state
 * after a period of no touches, and swallows the very tap that dismisses
 * it so it doesn't also land on whatever button happens to be underneath.
 */
export class IdleManager {
  private timer: number | undefined;
  private readonly overlay: HTMLElement;
  private armed = false;

  constructor(
    overlay: HTMLElement,
    private readonly timeoutMs: number,
    private readonly onIdle: () => void,
    private readonly onResume: () => void,
  ) {
    this.overlay = overlay;
    overlay.addEventListener("pointerdown", (e) => {
      e.preventDefault();
      this.dismiss();
    });
  }

  /** Call once the map has finished loading and the kiosk is ready for visitors. */
  start(): void {
    this.armed = true;
    for (const type of ["pointerdown", "keydown"]) {
      document.addEventListener(type, () => this.reset(), { passive: true });
    }
    this.reset();
  }

  private reset(): void {
    if (!this.armed) return;
    window.clearTimeout(this.timer);
    this.timer = window.setTimeout(() => this.goIdle(), this.timeoutMs);
  }

  private goIdle(): void {
    this.overlay.hidden = false;
    this.onIdle();
  }

  private dismiss(): void {
    if (this.overlay.hidden) return;
    this.overlay.hidden = true;
    this.onResume();
    this.reset();
  }
}
